import React from "react";
import { ColorIconProps, getColorIconSize } from "./utils";

const MapIcon: React.FC<ColorIconProps> = ({ size = "default", className }) => {
  return (
    <svg
      width={getColorIconSize(size)}
      height={getColorIconSize(size)}
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M3.33154 6.42857L9.33154 3V17.5714L3.33154 21V6.42857Z"
        fill="var(--cdl-accent-bg-base)"
        stroke="var(--cdl-accent-bg-base)"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.3313 6.42857L9.3313 3V17.5714L15.3313 21V6.42857Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.3313 6.42857L21.3313 3V17.5714L15.3313 21V6.42857Z"
        fill="var(--cdl-bg-base)"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default MapIcon;
